import { CallTargetType, InteractionType } from "@/common/types";
import { InteractionDirection, InteractionStatus } from "@/repository/models";
import { TargetSelectionSource } from "@/repository/models/outboundCall";

export interface NewInteractionData {
	name: string;
	value: string;
	selectionSource: TargetSelectionSource;
	contactId?: string;
	selectionType?: CallTargetType;
	selectionInteractionHistoryId?: string;
}

export interface NewInteraction {
	type: InteractionType;
	data?: NewInteractionData;
}

export interface CurrentInteractionState {
	active?: CurrentInteraction;
	new?: NewInteraction;
	preview?: CurrentInteractionPreview;
}

export interface CurrentInteractionActions {
	showNew: (data: NewInteraction) => void;
	showActive: (interaction: CurrentInteraction, hidePreview: boolean) => void;
	hideActive: () => void;
	hideNew: () => void;
	showPreview: (interaction: CurrentInteractionPreview) => void;
	hidePreview: () => void;
}

export enum SendType {
	Send,
	SendAndPark,
	SendAndClose,
}

export const SendTypeToLabelMapping: Record<SendType, string> = {
	[SendType.Send]: "Interaction.EmailEditor.Send",
	[SendType.SendAndClose]: "Interaction.EmailEditor.SendAndClose",
	[SendType.SendAndPark]: "Interaction.EmailEditor.SendAndPark",
};

export interface CurrentInteractionBase {
	type: InteractionType;
	id: string;
	contactInformation?: string;
	description?: string;
	name?: string;
	startDate?: string;
	firstAgentAssignedAt?: string;
	queueName?: string;
	queueId?: string;
	entryPointEmail?: string;
	direction?: InteractionDirection;
	sessionId?: string;
	isOnHold?: boolean;
	activeVariableText?: string;
	activeVariableTextIsAiGenerated?: boolean;
	offeringVariableText?: string;
	offeringVariableTextIsAiGenerated?: boolean;
	agentCallingEnabled?: boolean;
}

export interface CurrentInteraction extends CurrentInteractionBase {
	firstAgentId?: string;
	voicemailFilePath?: string;
	voicemailIsTranscriptionProcessed?: boolean;
	voicemailExpireDate?: Date;
	monitoringSupervisorId?: string;
	sendType?: SendType;
	wasTransferred?: boolean;
	wrapUpStopped?: boolean;
	isUnify?: boolean;
}

export interface CurrentInteractionPreview extends CurrentInteractionBase {
	isPickupEnabled: boolean;
	status: InteractionStatus;
}
